const DisplayTabs = {
  LIVE: 'live',
  HIGHLIGHTS: 'highlights'
}

export { DisplayTabs }
